import { render, staticRenderFns } from "./CandidateSocialLinks.vue?vue&type=template&id=c360093c&scoped=true"
import script from "./CandidateSocialLinks.vue?vue&type=script&lang=ts"
export * from "./CandidateSocialLinks.vue?vue&type=script&lang=ts"
import style0 from "./CandidateSocialLinks.vue?vue&type=style&index=0&id=c360093c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c360093c",
  null
  
)

export default component.exports